import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material'
import { Breadcrumbs, Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { ManualVoucherDetailsCard } from '@/entities/manual-attendance'
import { CustomButton } from '@/shared/ui/button'
import { PageWrapper } from '@/shared/ui/page-wrapper'

export const Route = createFileRoute(
  '/_auth/canteen/manual-attendance-and-food-receipt/item/$manualId'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleBack = () => {
    navigate({ to: '/canteen/manual-attendance-and-food-receipt/list' })
  }

  return (
    <PageWrapper title={t('Детали записи учета посещения столовой и получения питания')}>
      <Box display="flex" gap={2} alignItems="center">
        <CustomButton
          size="small"
          variant="outlined"
          color="secondary"
          startIcon={<ArrowBackIos />}
          onClick={handleBack}
        >
          {t('Назад')}
        </CustomButton>
        <Breadcrumbs separator={<ArrowForwardIos sx={{ fontSize: 16 }} />}>
          <Typography color="text.secondary" key="1">
            {t('Учёт посещения и активации ваучера')}
          </Typography>
          <Typography key="2" color="text.primary">
            {t('Детали записи')}
          </Typography>
        </Breadcrumbs>
      </Box>
      <ManualVoucherDetailsCard />
    </PageWrapper>
  )
}
